import { translateNumberToArabic } from "./translate-number-to-arabic.js";
const formatNumberWithZeroPrefix = (num, locale) => {
  const formattedNumber = num < 10 ? `0${num}` : `${num}`;
  return locale === "ar" ? formattedNumber.split("").map(translateNumberToArabic).join("") : formattedNumber;
};
export {
  formatNumberWithZeroPrefix
};
